export const APP_SIGN_IN_URL = "/login";
export const APP_SIGN_UP_URL = "/signup";
